import React from 'react';
import PropTypes from 'prop-types';
import AdvertisementAffiliateTileList from '../AdvertisementAffiliateTile';
import generateTestId from '../../utils/generateTestId';
import style from './style.scss';

const ConfirmationAdvertisement = ({partners}) => {
  return (
    <div
      className={style['confirmation-advertisement-container']}
      data-testid={generateTestId('confirmation-advertisement-container')}>
      <AdvertisementAffiliateTileList
        view="guest"
        placement="cashFundGuestPurchaseConfirmation"
        partners={partners}
      />
    </div>
  );
};

ConfirmationAdvertisement.propTypes = {
  partners: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ConfirmationAdvertisement;
